export default __webpack_public_path__ + "static/media/lifeleech6.f919fb08.png";